<template>
  <div
    class="w-full my-2 bg-grey-1 pt-2 px-4 md:rounded-t-lg border-b-2 border-blue-8 | thread-item thread-loading-item"
  >
    <div class="flex">
      <div class="flex-1 flex">
        <content-placeholders class="thread-loading-item-avatar">
          <content-placeholders-img
            class="border rounded-full border-yellow-6 relative w-12 h-12 mr-2"
          />
        </content-placeholders>
        <div class="flex flex-1 flex-col justify-between | thread-loading-item-user">
          <div>
            <content-placeholders class="w-full" :rounded="true">
              <content-placeholders-text :lines="1" />
            </content-placeholders>
          </div>
          <div class="flex">
            <content-placeholders class="w-full" :rounded="true">
              <content-placeholders-text :lines="1" />
            </content-placeholders>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h3
        class="my-2 py-2 -mx-4 px-4 bg-grey-0 text-xl flex items-center border-t border-b border-grey-3 | thread-loading-item-title"
      >
        <content-placeholders class="w-full flex items-center" :rounded="true">
          <content-placeholders-text :lines="1" />
        </content-placeholders>
      </h3>
    </div>

    <content-placeholders class="w-full | thread-loading-item-content mb-2" :rounded="true">
      <content-placeholders-text :lines="Math.floor(Math.random() * 5) + 3" />
    </content-placeholders>
  </div>
</template>

<script>
export default {
  name: "ThreadLoadingItem"
}
</script>

<style lang="scss" scoped>
</style>
